module.exports = __webpack_public_path__ + "img/12.72600466.png";